































































































import { computed, defineComponent, ref } from '~/utils/nuxt3-migration'
import CCard from '~/components/shared/configurable/card/CCard.vue'
import CImg from '~/components/shared/configurable/image/CImg.vue'
import TbiCalculator from '~/components/car/classifieds/view/partials/loans/calculator/tbi/TbiCalculator.vue'
import LoanPerks from '~/components/car/classifieds/view/partials/loans/perks/LoanPerks.vue'
import { useAnalytics } from '~/compositions/analytics'
import { v4 as uuidv4 } from 'uuid'
import { mapGetters } from 'vuex'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import SantanderCalculator from '~/components/car/classifieds/view/partials/loans/calculator/santander/SantanderCalculator.vue'
import AlphaCalculator from '~/components/car/classifieds/view/partials/loans/calculator/alpha/AlphaCalculator.vue'
import TbiInfoModal from '~/components/car/classifieds/view/partials/loans/calculator/tbi/TbiInfoModal.vue'
import { useDep } from '~/compositions/dependency-container'
import PopularityService from '~/services/popularity/PopularityService'
import { useNamespacedStore } from '~/compositions/store'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'
import {
  CLASSIFIED_VIEW_NS,
  ClassifiedViewState
} from '~/store/modules/shared/classifieds/view/state'
import PiraeusConsumerCalculator from '~/components/car/classifieds/view/partials/loans/calculator/piraeus/PiraeusConsumerCalculator.vue'

export default defineComponent({
  components: {
    PiraeusConsumerCalculator,
    TbiInfoModal,
    AlphaCalculator,
    SantanderCalculator,
    LoanPerks,
    TbiCalculator,
    CImg,
    CCard
  },
  computed: {
    ...mapGetters(USER_AGENT_NS, {
      isPc: 'isPc'
    })
  },
  props: {},
  setup() {
    const analytics = useAnalytics()
    const randomId = uuidv4()

    const { getters } = useNamespacedStore<ClassifiedViewState>(
      CLASSIFIED_VIEW_NS
    )

    const loanCalculators = computed(() =>
      getters('loanCalculatorsWithoutPiraeusMortgage')
    )

    const tbiExpanded = ref(false)
    const alphaExpanded = ref(false)
    const piraeusConsumerExpanded = ref(false)
    const showTbiInfoModal = ref(false)
    const onVisible = () => {
      analytics.recordEvent({
        namespace: 'n_classified_view_loans_visible',
        action: 'load',
        label: randomId
      })
    }

    const popularityService = useDep(PopularityService)

    const { getters: userGetters } = useNamespacedStore<UserState>(USER_NS)
    const isAdmin = computed(() => userGetters('isAdmin'))

    const handleExpand = (bank: string, expanded: boolean) => {
      if (expanded) {
        if (bank === 'tbi') {
          alphaExpanded.value = false
          piraeusConsumerExpanded.value = false
        } else if (bank === 'alpha') {
          tbiExpanded.value = false
          piraeusConsumerExpanded.value = false
        } else if (bank === 'piraeus') {
          alphaExpanded.value = false
          tbiExpanded.value = false
        }

        popularityService.recordEvent('public_loan_calculator_opened', {
          page_location: 'classified_view',
          merchant: bank,
          session_id: randomId
        })
      }
    }

    const showTbiLogo = computed(() => {
      return (
        loanCalculators.value.length === 1 &&
        ['auto-loan', 'consumer-loan'].includes(
          loanCalculators.value[0].loanType
        )
      )
    })
    const showSantanderLogo = computed(() => {
      return (
        loanCalculators.value.length === 1 &&
        loanCalculators.value[0].loanType === 'santander-loan'
      )
    })

    return {
      randomId,
      onVisible,
      tbiExpanded,
      alphaExpanded,
      piraeusConsumerExpanded,
      handleExpand,
      showTbiInfoModal,
      showTbiLogo,
      showSantanderLogo,
      isAdmin,
      loanCalculators
    }
  }
})
